export const servicesCategories = ['Studios', 'Rentals', 'Technicians', 'About Us'];

export const USER_INFORMED_ABOUT_COOKIES_USAGE = 'USER_INFORMED_ABOUT_COOKIES_USAGE';



// WEBPACK FOOTER //
// ./src/utils/variables.js